import { Address } from "@core/types";
import React, { createContext, useContext, useState } from "react";

const CustomerAddressesStateContext = createContext<{
  token: string;
  setToken: (token: string) => void;
  customerAddress: Address | undefined;
  setCustomerAddress: (value: Address | undefined) => void;
  isAddressModalOpen: boolean;
  setIsAddressModalOpen: (value: boolean) => void;
}>(undefined!);

export const CustomerAddressesStateProvider = ({ children }: { children: React.ReactChild }) => {
  const [token, setToken] = useState("");

  const [customerAddress, setCustomerAddress] = useState<Address>();
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);

  return (
    <CustomerAddressesStateContext.Provider
      value={{
        token,
        setToken,
        customerAddress,
        setCustomerAddress,
        isAddressModalOpen,
        setIsAddressModalOpen,
      }}
    >
      {children}
    </CustomerAddressesStateContext.Provider>
  );
};

export const useCustomerAddressesStateData = () => useContext(CustomerAddressesStateContext);

const CustomerAddressSelectContext = createContext<{
  isAddressSelectOpen: boolean;
  setIsAddressSelectOpen: (value: boolean) => void;
}>(undefined!);

export const CustomerAddressSelectProvider = ({ children }: { children: React.ReactChild }) => {
  const [isAddressSelectOpen, setIsAddressSelectOpen] = useState(false);

  return (
    <CustomerAddressSelectContext.Provider
      value={{
        isAddressSelectOpen,
        setIsAddressSelectOpen,
      }}
    >
      {children}
    </CustomerAddressSelectContext.Provider>
  );
};

export const useCustomerAddressSelectData = () => useContext(CustomerAddressSelectContext);
